import { jsx as _jsx } from "react/jsx-runtime";
import MuiTypography from "@mui/material/Typography";
const Typography = (properties) => (_jsx(MuiTypography, Object.assign({ variantMapping: {
        body: "p",
        lead: "p",
    }, variant: "body" }, properties)));
export default Typography;
